<template>
  <div>
    <span class="isolate inline-flex rounded-md shadow-sm">
      <template v-if="orderItem.projectId">
        <RouterLink
          class="first:rounded-l-md last:rounded-r-md relative -ml-px inline-flex items-center border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
          :to="{
            name: 'accounts.projects.project',
            params: {
              accountId: customerAccountId,
              projectId: orderItem.projectId,
            },
          }"
        >
          Go to project
        </RouterLink>
        <button
          v-if="!orderItem.producableType"
          type="button"
          class="first:rounded-l-md last:rounded-r-md relative -ml-px inline-flex items-center border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
          @click="removeFromProject"
        >
          Remove from project
        </button>
      </template>
      <button
        v-else
        type="button"
        class="first:rounded-l-md last:rounded-r-md relative -ml-px inline-flex items-center border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
        @click="addToProject"
      >
        Add to project
      </button>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    orderItem: {
      type: Object,
      required: true,
    },
    accountId: {
      type: String,
      required: true,
    },
    customerAccountId: {
      type: String,
      required: true,
    },
    defaultProjectData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    addToProject() {
      this.$modal.show({
        component: () => import('./projectSelectOrCreateDialog/ProjectSelectOrCreateDialog.vue'),
        props: {
          accountId: this.accountId,
          customerAccountId: this.customerAccountId,
          defaultProjectData: this.defaultProjectData,
        },
        on: {
          select: (projectId) => {
            this.$emit('change', projectId);
          },
        },
        hideEvent: 'close',
      });
    },
    goToProject() {},
    removeFromProject() {
      this.$emit('change', null);
    },
  },
};
</script>
